<template>
  <div class="page">
    <car-introduction></car-introduction>
    <car-service id="service" />
<!--    <chartered-car id="chartered" />-->
    <phone class="phone" />
  </div>
</template>

<script>
import CarIntroduction from '@/components/Moudle/CarIntroduction/CarIntroduction.vue'
import CharteredCar from '@/components/Moudle/CarIntroduction/CharteredCar.vue'
import CarService from '@/components/Moudle/CarService/CarService.vue'
import Phone from '@/components/Common/Phone/phone.vue'

export default {

  components: { CarService, CarIntroduction,Phone},
  data() {
    return {}
  },
  mounted() {
    // if (this.$route.query.type == 2) {
    //   this.$nextTick(() => {
    //     let top = document.getElementById('service').offsetTop
    //     window.scrollTo({ top: top, behavior: 'smooth' })
    //   })
    // }
    if (this.$route.query.type == 2) {
      this.$nextTick(() => {
        let top = document.getElementById('chartered').offsetTop
        window.scrollTo({ top: top, behavior: 'smooth' })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  background: $bg-color;
  padding: 0px 0 90px;
}
.phone {
  margin-top: 47px;
}
</style>
